import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { SearchClientComponent } from 'src/app/components/search-client/search-client.component';
import { ClientExtendsComponent } from '../../client/client-extends/client-extends.component';
import * as moment from 'moment';
import { ToolsService } from 'src/app/utils/tools.service';
import { GeneralService } from 'src/app/api/config/general.service';
import SwalAlert from 'src/app/utils/swalalert';
import { ProformaService } from 'src/app/api/sale/proforma.service';
import { AmountTextService } from 'src/app/utils/amount-text.service';
import { AccountbankService } from 'src/app/api/finance/accountbank.service';
declare var $: any;

@Component({
  selector: 'app-proforma-form',
  templateUrl: './proforma-form.component.html',
  styleUrls: ['./proforma-form.component.css']
})
export class ProformaFormComponent implements OnInit {
  @ViewChild(SearchClientComponent) SearchClientComponent: any;
  @ViewChild(ClientExtendsComponent) ClientExtendsComponent: any;
  private thisComponent: ProformaFormComponent;

  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  clientSelected: any = null;
  currencySelected: any = null;
  currencies: any = [];
  products: any = [];
  accountbanks: any = [];

  subtotal: any = 0;
  total_igv: any = 0;
  total_proforma: any = 0;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private proformaService: ProformaService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private generalService: GeneralService,
    private accountbankService: AccountbankService,
    public toolsService: ToolsService,
    private alert: SwalAlert,
    private amountTextService: AmountTextService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.thisComponent = this;
    this.item = this.fb.group({
      client_id: [null, [Validators.required]],
      accountbank_id: [null],
      nro_voucher: [null],
      cellphone: [null],
      email: [null],
      address: [null],
      observation: [null],
      date_issue: [moment().format('YYYY-MM-DD')],
      date_expiration: [
        moment()
          .add(1, 'months')
          .format('YYYY-MM-DD')
      ],
      is_igv: [false],
      igv: [null],
      subtotal: [null],
      total: [null],
      text_amount: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    this.getCurrencies();
    this.getAccountBanks();
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.proformaService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.proforma;
        this.item.patchValue({
          client_id: item_.client_id,
          accountbank_id: item_.accountbank_id,
          nro_voucher: item_.nro_voucher,
          cellphone: item_.cellphone,
          email: item_.email,
          address: item_.address,
          observation: item_.observation,
          date_issue: item_.date_issue,
          date_expiration: item_.date_expiration,
          is_igv: item_.is_igv,
          igv: item_.igv,
          subtotal: item_.subtotal,
          total: item_.total,
          text_amount: item_.text_amount
        });

        this.selectedClientSearch(item_.client_data);
        this.products = data.detail;
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getCurrencies() {
    this.generalService.listCurrencies().subscribe({
      next: (data: any) => {
        this.currencies = data.results;
        for (let i in this.currencies) {
          if (this.currencies[i].is_principal) {
            this.item.patchValue({
              currency_id: this.currencies[i].id
            });
            this.currencySelected = this.currencies[i];
          }
        }
      }
    });
  }

  getAccountBanks() {
    this.accountbankService.all().subscribe({
      next: (data: any) => {
        this.accountbanks = data.results;
      }
    });
  }

  changeBankAccount(param: any) {
    let value_ = param.value;
    if (value_ == 'null') {
      value_ = null;
    }
    this.item.patchValue({
      accountbank_id: value_
    });
  }

  // datos cliente ================
  selectedClientSearch(item_: any) {
    this.clientSelected = item_;
    this.item.patchValue({
      client_id: item_.id
    });
  }

  removeClient() {
    this.clientSelected = null;
    this.item.patchValue({
      client_id: null
    });
    setTimeout(() => {
      this.SearchClientComponent.focused();
    }, 150);
  }

  extendsClient(event: any): void {
    this.selectedClientSearch(event);
  }
  // end cliente ======================

  // product action ======================

  selectedProductSearch(item: any) {
    if (this.ifExistItem(item)) {
      item.detail_id = null;
      item.unit_id = 0;
      item.quantity = 1;
      item.price = item.price_sale;
      item.detail = null;
      item.igv = 0;
      item.equivalence = null;

      let subtotal_ = Number(
        Number(item.price) * Number(item.quantity)
      ).toFixed(2);
      item.subtotal = subtotal_;
      // asignar unidad de medida
      item.unit_id = item.unitsmeasure[0].id;
      this.products.push(item);
      this.recalculateTotal();
    } else {
      this.alertifyMsg.warning(
        'El producto ' + item.description + ' ya se encuentra agregado'
      );
    }
  }

  ifExistItem(product: any) {
    let response = false;
    if (this.toolsService.notExistObjInArr(product, this.products)) {
      response = true;
    }
    return response;
  }

  changeUnitSelected(param: any, index: number, product: any): void {
    let value_ = param.value;
    let unitselected_ = this.toolsService.searchObjById(
      value_,
      product.unitsmeasure
    );
    this.products[index].unit_id = unitselected_.id;
    this.products[index].price = unitselected_.price_sale;
    this.changeSubtotal(index);
  }

  changeQuantity(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.products[index].quantity = value_;
    }
    this.changeSubtotal(index);
  }

  changePrice(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.products[index].price = value_;
    }
    this.changeSubtotal(index);
  }

  changeSubtotal(index: any) {
    let subtotal_ = this.products[index].price * this.products[index].quantity;
    this.products[index].subtotal = Number(subtotal_).toFixed(2);
    this.recalculateTotal();
  }

  removeProduct(id: any, index: any) {
    this.alertifyMsg.warning(
      'El producto ' +
        this.products[index].description +
        ' ha sido removido del detalle'
    );
    this.products.splice(index, 1);
    this.recalculateTotal();
  }

  recalculateTotal() {
    let total_ = 0;
    for (let i in this.products) {
      let item_ = this.products[i];
      total_ = total_ + Number(item_.subtotal);
    }
    this.subtotal = Number(total_).toFixed(2);
    this.total_igv = Number(0).toFixed(2);
    this.total_proforma = this.subtotal;
  }

  // end product action ======================

  preSubmit() {
    // if (this.item.invalid) {
    //   return;
    // }

    if (this.validate()) {
      let options = {
        title: 'Atención',
        message: 'Esta seguro(a) de generar el registro de la proforma?',
        cancel: 'Cancelar',
        confirm: 'Sí, GENERAR PROFORMA !'
      };
      this.alert.confirmInfo(options).then((result: any) => {
        if (result.isConfirmed) {
          this.submitted = true;
          this.onSubmit();
        }
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    const currencyName =
      this.currencySelected.currency === 'USD' ? 'Dólares Americanos' : 'Soles';

    this.item.patchValue({
      igv: this.total_igv,
      subtotal: this.subtotal,
      total: this.total_proforma,
      text_amount: this.amountTextService.letras(
        this.total_proforma,
        currencyName, // <- segundo parámetro de la función letras
        true // <- tercera opción: mayúsculas
      )
    });

    let data: any = {};
    data.proforma = this.item.value;
    data.products = this.products;

    if (this.validate()) {
      if (this.isEdit) {
        this.proformaService.update(this.checkId, data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.proformaService.save(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    if (this.products.length === 0) {
      let options = {
        title: 'Advertencia !',
        message:
          'Debe ingresar por lo menos un producto al detalle de la proforma'
      };
      this.alert.warning(options);
      return false;
    } else {
      for (let i in this.products) {
        let product = this.products[i];
        if (Number(product.quantity) == 0 || _.isNull(product.quantity)) {
          this.alertifyMsg.warning(
            'La cantidad del producto ' +
              product.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          (<any>$('#quantity' + i)).focus();
          return false;
        }

        if (Number(product.price) == 0 || _.isNull(product.price)) {
          this.alertifyMsg.warning(
            'El precio del producto ' +
              product.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          (<any>$('#price' + i)).focus();
          return false;
        }
      }
    }

    if (this.total_proforma == 0) {
      let options = {
        title: 'Advertencia !',
        message: 'El total de la proforma no puede ser igual a cero'
      };
      this.alert.warning(options);
      return false;
    }

    if (_.isNull(this.item.value.client_id)) {
      this.alertifyMsg.warning(
        'Debe seleccionar el cliente asociado a la proforma'
      );
      this.SearchClientComponent.focused();
      return false;
    }

    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/ventas/proformas/lista']);
  }
}
